'use strict';

const { Store } = require("./Reducers");
const { actions } = require("./Actions");

module.exports = {
    Store,
    actions
};